import { MAINTENANCE, SLUDGE_EMPTYING, SPANC } from '../utils/rikutec';

const locale = {
    app: {
        actions: {
            refresh: 'Refresh',
            addItem: 'Create',
            editItem: 'Edit',
            deleteItem: 'Delete',
            title: 'Actions'
        },
        ancsV2: {
            actions: {
                history: 'History',
                forms: 'Forms',
            },
            subtabs: {
                install: 'Installation',
                installHint: 'Tracking, product and soil typology',
                coord: 'Contact details',
                coordHint: 'Owner, site, installer and distributor',
                recep: 'Works acceptance',
                recepHint: 'Acceptance report and status of reserves',
            },
            formsTitle: 'traceability',
            signatures: {
                owner: 'Project owner',
                installer: 'Contractor',
                ownerRole: 'owner',
                installerRole: 'installer',
                signed: 'Signed',
                pending: 'Pending',
                missing: 'Not signed',
                unavailable: 'Signature not available',
                others: 'Other signatures',
            },
            files: {
                title: 'Files',
                document: 'Document',
                step: 'Step',
                date: 'Date',
                action: 'Action',
                empty: 'No file in the history',
                error: 'The history files could not be loaded',
                download: 'Download',
            },
            personalData: 'Personal data',
            process: {
                older: 'Older process',
                current: 'Current process',
                both: 'Older then current process',
                pose: 'Pose by the installer',
                landOwner: 'Pose by the land owner',
                commissioning: 'Commissioned by the owner',
                noForm: 'No form in the history',
            },
            checks: {
                waterRunoff: 'Siting: runoff water diverted',
                steepSlope: 'Siting: steep slope secured',
                devicesInWater: 'Siting: no more than 1.10 m in water',
                evacuationAndVentilation: 'Siting: drainage and ventilation compliant',
                noLoadWithin3Meters: 'Siting: no load within 3 m',
                rapidRecovery: 'Siting: quick vegetation recovery',
                notInFloodProneArea: 'Siting: outside flood-prone area',
                waterDecanter: 'Settling tank filled with water',
                basketInPlace: 'Basket in place in the septic tank',
                downstreamLiftingDevice: 'Optional downstream lifting working and secure',
                biologicalWaterReactor: 'Biological reactor filled, control box connected',
                gravityFlow: 'Gravity flow from the supply pipe',
                biologicalFilterVentilation: 'Biological filter ventilation working',
                closedAndSecureBuffers: 'Covers closed and secured',
                ownerInformed: 'Owner informed of how it works',
            },
            groups: {
                information: 'Information',
                tracking: 'Tracking',
                product: 'Product information',
                client: "Owner's details",
                installation: 'Installation site',
                installer: "Installer's details",
                distributor: "Distributor's details",
                soil: 'Soil typology',
                reception: 'Works acceptance report',
                reserves: 'Status of reserves',
                signatures: 'Signatures',
                siteChecks: 'Installation checks',
            },
            columns: {
                model: 'Model',
                lastMaintenance: 'Last maintenance',
                lastEmptying: 'Last emptying',
                processingCapacity: 'Processing capacity',
                clientFullName: 'Client',
                installerCompany: 'Installer',
                installationCity: 'Installation city',
                readyToDeliverDate: 'Ready to deliver',
                poseDate: 'Installation date',
                reserveLiftDate: 'Lift the reserves',
                hasOwnerSignature: 'Project owner signature',
                hasInstallerSignature: 'Contractor signature',
            },
            // Wording of the Rikutec process forms (coreapi, RikutecExtBundle CreateProcess* commands).
            forms: {
                loadError: 'Could not load all the information of this installation',
                notAsked: 'Not asked by this process',
                lastName: 'Last name',
                firstName: 'First name',
                company: 'Company',
                address: 'Address',
                postalCode: 'Postal code',
                city: 'City',
                country: 'Country',
                email: 'Email',
                phone: 'Phone',
                invoiceDate: 'Installation or invoice date',
                serialNumber: 'Product serial number',
                nominalCapacity: 'Nominal capacity',
                totalUsefulVolume: 'Total useful volume',
                sludgeStorageVolume: 'Sludge storage volume',
                stableBedding: 'Permeable, stable soil: bedding',
                stableBackfilling: 'Permeable, stable soil: side backfilling',
                impermeableSlab: 'Impermeable soil: reinforced concrete slab',
                impermeableBedding: 'Impermeable soil: lean concrete bedding',
                impermeableBackfilling: 'Impermeable soil: side backfilling',
                unstableBedding: 'Unstable soil: lean concrete bedding',
                unstableBackfilling: 'Unstable soil: side backfilling',
                quoteNumber: 'Quote no.',
                workInformation: 'Related works',
                withReserve: 'Acceptance with reserves',
                conditionsReceived: 'Conditions of use and maintenance received',
                madeIn: 'Made in',
                madeOn: 'On',
                privacyAccepted: 'Privacy policy accepted',
                kindOfReserve: 'Nature of the reserves',
                workToBePerformed: 'Work to be carried out',
                workPeriod: 'Overall completion period',
                answers: {
                    yes: 'Yes',
                    no: 'No',
                },
                soilOptions: {
                    form8: 'Installation in permeable, stable soil without groundwater',
                    form9: 'Installation in impermeable ground or with groundwater',
                    form10: 'Installation in unstable or poorly permeable soil, without groundwater',
                },
            },
            filters: {
                clientFullName: 'Client',
                installerCompany: 'Installer',
                distributorCompany: 'Distributor',
                installationCity: 'Installation city',
            },
        },
        ancs: {
            qrScan: {
                button: 'Scan QR',
                clear: 'Show all',
                title: 'Scan the item QR',
                hint: 'Place the QR code inside the frame',
                notFound: 'No item found for this QR',
                searchFailed: 'Search failed',
                cameraNotAvailable: 'Camera not available or already in use',
                permissionDenied: 'Camera access denied',
                noCamera: 'No accessible camera',
                selectCamera: 'Camera',
                camera: 'Camera',
            },

            departmentFilter: {
                label: 'Departments',
                all: 'all',
                title: 'Click the departments to show',
                selected: 'Selected',
                hint: 'Only ANCs with a postal code can be found.',
                clear: 'Clear all',
                cancel: 'Cancel',
                apply: 'Apply',
            },

            level1: 'Level 1',
            level2: 'Level 2',
            level3: 'Level 3',
            level4: 'Level 4',
            level5: 'Level 5',
            postalCode: 'Postal Code',
            name: 'Name',
            articleNumber: 'Item number',
            productTypology: 'Product typology',
            serialNumber: 'Serial number',
            installingDate: 'Installing date',
            maintenanceLastDate: 'Last maintenance',
            sludgeEmptyingLastDate: 'Last sludge emptying',
            maintenanceThreshold: 'Maintenance threshold',
            sludgeEmptyingThreshold: 'Sludge emptying threshold',
            sludgeEmptyingThresholdFilterDate: 'Filter by period and event plotted',
            sludgeEmptyingThresholdFilterLastDate: 'Period per drain',
            sludgeMaintenanceThresholdFilterLastDate: 'Period per maintenance',
            sludgeEmptyingThresholdOrMaintenanceFilterDate: 'Last sludge emptying',
            addFilter: 'Add Filter',
            customize: 'Customize',
            refresh: 'Refresh',
            thresholdName: 'Level label',
            thresholdMinValue: 'Min Value',
            thresholdMaxValue: 'Max Value',
            thresholdTriggerValue: 'Trigger Value',
            thresholdMinTriggerValue: 'Range lower limit',
            thresholdMaxTriggerValue: 'High limit of the interval',
            thresholdMonthValue: 'Month',
            addThreshold: 'Add level',
            processingCapacity: 'Processing capacity',
            sludgeStorageVolume: 'Sludge storage volume',
            totalUsefulVolume: 'Total useful volume',
            nodeCurrentState: 'Current status',
            nodeStateName: 'Status name',
            nodeDateOfTakesPlace: 'Date of the current status',
            model: 'Model',
            weeks: 'Weeks',
            hours: 'Hours',
            days: 'Days',
            years: 'Years',
            month: 'Month',
            accessToFinger: 'Field view',
            vueSpecifique: 'Specific view',
            backofficeForms: 'Fill forms',
            backofficeDocuments: 'Upload documents',
            backofficeMissingRefresh:
                'No session (refresh token). Sign in again in the backoffice to open the app as your user.',
            [MAINTENANCE]: 'Maintenance',
            [SLUDGE_EMPTYING]: 'Sludge emptying',
            [SPANC]: 'Spanc',
            actions: {
                title: 'Actions',
                managementThresholds: 'Management of thresholds',
                defineThresholds: 'List of alert levels, based on time intervals since last operation',
                export: 'Export',
                statistics: 'Statistics',
                refresh: 'Refresh',
                personalize: 'Personalize',
                editVP: 'Add / Edit VP',
                editWC: 'Add / Edit warranty certificate',
                mapAvatars: 'Geolocated ANCs',
                realTimeMonitoring: 'Ancs monitoring',
                scheduledMonitoring: 'Ancs monitoring',
                productTypology: 'Product Type',
                types: 'Types',
                thresholds: 'Threshold Settings'
            },
            error: {
                server: 'An error was found. Please contact the administrator',
                requiredField: 'Required field',
                wrongMinAmount: 'Wrong min amount',
                minMustExceedPreviousMax: 'Value must be greater than the previous max',
                wrongMaxAmount: 'Wrong max amount',
                maxMustExceedPreviousMin: 'Value must be greater than previous min',
                greaterThanZero: 'Cannot be negative'
            },
            metadataAvatarType: {
                name: 'Object type name'
            },
            help_text: {
                once_validated:
                    'Once validated, to see the document sent, click on the button in the “Field view” column'
            },
            success: {
                success: 'Data has saved',
                media_uploaded: 'The selected media has been uploaded',
                media_updated: 'The selected media has been updated'
            }
        },
        button: {
            confirm: 'Confirm',
            submit: 'Submit',
            cancel: 'Cancel',
            go: {
                toThresholdPage: 'Go to threshold view',
                toAncsPage: 'Go to Ancs view'
            }
        },
        common: {
            after: 'After',
            before: 'Before',
            loading: 'Loading, please wait',
            loadingMapData: 'Loading map data...',
            page: 'Page',
            of: 'of',
            loaded: 'Loaded',
            items: 'items',
            requests: 'Requests',
            remaining: 'remaining'
        },
        dashboard: {
            title: 'Dashboard',
            creationObjet: 'Objects Creation History',
            subtitle: 'Objects created over the period',
            granularity: {
                hours: 'Hour',
                day: 'Day',
                month: 'Month'
            },
            period: {
                menu: 'Period',
                lastWeek: 'Last week',
                lastMonth: 'Last month',
                lastYear: 'Last year'
            },
            dateFrom: 'After',
            dateTo: 'Before',
            groups: {
                label: 'Object groups',
                title: 'Select object groups',
                name: 'Name',
                none: 'All groups'
            },
            error: 'Could not load the chart'
        },
        errors: {
            updatingProperty: 'There was an error during the update of a property',
            creatingProperty: 'There was an error during the creating of a property',
            updatingType: 'There was an error during the update of a type',
            creatingType: 'There was an error during the creation of a type',
            gettingLanguage: 'There was an error during the fetching of property language',
            languages: 'There was an error while fetching the languages'
        },
        headers: {
            eyebrow: {
                overview: 'Overview',
                realTime: 'Installation tracking · real time',
                every2Hours: 'Installation tracking · updated every 2 hours',
                reference: 'Reference data and administration',
            },
            description: 'Description',
            additional_info: 'Additional Information',
            info: 'Information',
            type: 'Types',
            types: 'Types',
            selectAvatarTypeGroup: 'Select Product Type',
            confirmDelete: 'Remove',
            productTypeData: 'Product Type',
            productType: 'Product Type',
            ancs: 'Ancs monitoring',
            thresholds: 'Threshold Settings'
        },
        mc: {
            add: 'Add',
            application: 'Redirection service',
            changePict: 'Change picture',
            copy: 'Copy URL',
            creationDate: {
                afterFilter: 'After',
                beforeFilter: 'Before',
                value: 'Creation Date'
            },
            downloadQrcode: 'Download QR Code',
            edit: 'Edit',
            editDialogTitle: 'Modify MC',
            enabled: {
                no: 'No',
                yes: 'Yes'
            },
            exportQrcode: 'Export QR Code',
            general: 'General',
            identification: 'Communication module identification',
            information: 'Information',
            mcName: 'Name communicating modules',
            name: 'Name',
            parameter: 'Parameter "MC"',
            remove: 'Remove',
            showQrcode: 'See QR Code',
            visitApp: 'View the application',
            yourls: {
                shortUrl: 'short URL'
            }
        },
        medias: {
            addApproval: 'Add approval',
            addTechnicalSheet: 'Add technical sheet',
            addRoutineMaintenance: 'Add routine maintenance',
            addUserGuide: 'Add user guide',
            addInstallingGuide: 'Add installing guide',
            mediaFile: 'Upload a media',
            addReflexMaintenance: 'Add the Reflex Maintenance sheet',
            addReflexEmptying: 'Add the Drain Reflex Sheet',
            addUserBooklet: 'Add User booklet'
        },
        messages: {
            confirmDelete: 'Do you want to delete this line?',
            confirmOperation: 'You are about to delete an item. Are you sure you want to continue?',
            canSendApprovalLater: 'You can send the approval latter',
            loading: 'Loading, please wait',
            error: 'Something went wrong, please notify the admin',
            success: 'Operation was successful'
        },
        no: 'No',
        objects: {
            by: 'By',
            noNotes: 'No notes',
            details: 'Details',
            notes: 'Notes',
            description: 'Description',
            mc: 'MCs',
            service: 'Service',
            qrCode: 'QR Code',
            info: {
                name: 'Name of object',
                type: 'Type of object',
                description: 'Description',
                reference: 'Reference',
                created: 'Date of creation',
                enterprise: 'Company',
                images: 'Images',
                audios: 'Audios',
                documents: 'Documents',
                signatures: 'Signatures',
                externalIdentification: 'External identification',
                forms: 'Forms',
                gps: 'GPS',
                filter: {
                    filter: 'Filter',
                    name: 'Name',
                    note: 'Note',
                    traceability: 'Traceability'
                }
            },
            filters: {
                avatarProperties: {
                    additionalInformation: 'Additional information'
                }
            },
            infoTab: 'Information'
        },
        objects2: {
            actions: {
                additionalInformation: 'Additional Information',
                changeTraceability: 'Change Traceability',
                changeWebApp: 'Change Web App',
                deleteAction: {
                    keepMcsName: 'Delete and keep the Communication module',
                    name: 'Delete'
                },
                simulateWebApp: 'Simulate Web App'
            },
            addImages: 'Click here to add images',
            addObject: 'Add an object',
            additionalInformation: {
                actions: {
                    addNewName: 'New name',
                    addProperty: 'Add Property',
                    createGSTemplate: 'Create G-Sheet Template',
                    editProperty: 'Edit Property',
                    hidePrivate: 'Hide Private Properties',
                    importDataGS: 'Import Data G-Sheet',
                    importDataTypeObject: 'Import a data of the type of object',
                    showPrivate: 'Show Private Properties'
                },
                addProperty: {
                    finish: 'Finish',
                    helpText:
                        'Define the additional information. The choice of display makes it possible to define whether the information is accessible without a password from the compatible Mobile Web Applications (contact us for more information). The definition allows information to be grouped together'
                },
                creator: 'Creator',
                definition: 'Name definition (The definition allows information to be grouped together)',
                error: {
                    addColumnsData: 'Something went wrong when add columns in sheet SC-DATA',
                    addDataTypes: 'Something went wrong when add fields of properties in sheet SC-DATA-TYPE',
                    addSheets: 'Check that the G-Sheet has no data',
                    googleSheetLine: 'Line number must be greater than one',
                    noData: 'No data found.',
                    noValue: 'Undefined value',
                    properties: 'You should add at least one property',
                    spreadsheet: 'Something went wrong when importing the data from the Spreadsheet',
                    spreadsheetURL: 'The URL should be a Spreadsheet'
                },
                fieldType: 'Information type',
                fieldTypeOptions: {
                    boolean: 'Boolean',
                    date: 'Date',
                    number: 'Integer',
                    string: 'Text'
                },
                googleSheetURL: 'G-Sheet URL',
                helpText: {
                    additionalInformation: 'Configure the additional information you want to record about your object',
                    createSpreadsheetsTemplate: 'Configure the properties you want to generate in your G-Sheet file',
                    definition: 'The definition allows information to be grouped together.',
                    fieldType:
                        'The type of information is a parameter that can be used in third party functionalities or a compatible Mobile Application (contact us to find out more).',
                    googleSheet:
                        'To import data from a G-Sheet file, please ensure that the data format is compatible.',
                    googleSheetLine: 'You must write the line number to import.',
                    googleSheetURL: 'Please insert the G-Sheet file share link.',
                    name: 'Define the title additional information',
                    private:
                        'The choice of display defines whether the information is accessible without a password from the compatible Mobile Web Applications (contact us for more information).',
                    spreadsheetCreate: 'The G-Sheet template was create',
                    unit: 'Unit of the information'
                },
                lineNumber: 'Choice number of line',
                lineToImport: 'Choice number of line (example "1-4")',
                name: 'Information title',
                private: 'Display Rule',
                privateOptions: {
                    private:
                        'Private: the information data will be encrypted and can be visible when a user with the rights is identified.',
                    public: 'Public: the information will be visible without needing to identify with an account from the Web Applications using the additional information of the object.'
                },
                title: 'Additional Information',
                tooltipActionIcons: {
                    edit: 'Edit',
                    private: 'Private Information',
                    remove: 'Remove',
                    required: 'Required Information'
                },
                unit: 'Unit',
                value: 'Information Value (data)'
            },
            _date: 'Creation date',
            alphaId: 'Reference',
            applications: 'Redirections',
            bulk_action: {
                addToObjectGroup: 'Group',
                addTraceability: 'Traceability',
                changeFinger: 'Redirection',
                error: {
                    diferentCompany:
                        'Please verify that all objects belong to the same object group account %{object_group_name}',
                    headerTable: 'Error',
                    notAdded: 'It was not added to the group',
                    notChangeApp: 'The redirection service was not changed',
                    notChangeTraceability: 'The traceability was not changed',
                    notRemoveFromGroup: 'It was not removed from the group',
                    title: 'Some objects were not updated',
                    titleUpdateMCs: 'Some MCs were not updated'
                },
                removeToObjectGroup: 'Ungroup',
                titleAddToGroup: 'Choose the object group to apply to the selected objects',
                titleAddTraceability:
                    'Choose the traceability process to change. Note that the change only works if the object uses a web application that relies on traceability (e.g. MemoTagPro)',
                titleChangeFinger: 'Choose the redirection to apply to the selected objects',
                titleChangeFingerForMC: 'Choose the redirection to update the communication module',
                titleRemoveGroup: 'Choose the group you want to detach from the selected object'
            },
            createModal: {
                p1text1: 'For register or add an object on the platform, you must use the',
                p1text2: 'mobile pairing application',
                p1text3: ' on the',
                p1text4: 'real object',
                p1text5: 'integrating one or more communicating module (s) NFC or Qrcode type.',
                p2text1: 'For more information contact the',
                p2text2: 'support'
            },
            createObject: {
                advancedForm: 'Advanced Form',
                error: {
                    addToGroup: 'Could not add object to object group',
                    createMc: 'MC could not be created',
                    simulateMc: 'The MC simulation was not done'
                },
                finger: {
                    add: 'Add Redirection'
                },
                groupObjects: {
                    add: 'Objects Group'
                },
                helpText: {
                    chooseTypeObject: 'Choose your object type for pre configure your new object:',
                    createObject:
                        'You are about to create an object manually. There is a more optimized way to create an object, for that see this page.',
                    createObjectPage: 'How to create an object'
                },
                notification: {
                    addToGroup: 'The object was added to the group',
                    copied: 'Copied to clipboard'
                },
                simplifiedForm: 'Simplified Form',
                title: 'Create object',
                validatePrevData: 'Validate the pre-filled data'
            },
            createObjectMultiple: {
                errors: {
                    emptyLine: 'Something went wrong. Some line without value.',
                    nogapi: 'Unable to access google api. Please contact the service administrator.',
                    notFoundDataInTableInSpreadsheet: '%{table} dont have data',
                    notFoundPropertyInTable: '%{property} property is not on %{table} table',
                    notFoundTableInSpreadsheet: '%{table} was not found on spreadsheet',
                    readLine: 'Line numbers to import have no data',
                    spreadsheet: 'Something went wrong when importing the data from the Spreadsheet'
                },
                helpText: {
                    amount: 'Amount of objects to create',
                    step1CreateObject: 'How to create an object',
                    step1Part1:
                        'You are about to create an object manually. There is a more optimized way to create an object, for that see this page',
                    step1Part2: 'Choose your object type for pre-configure your new object',
                    step2ValidatePreFillData: 'Validate this pre-filled data',
                    step3Line1: 'To import data from a G-Sheet file, please ensure that the data format is compatible.',
                    step3Line2: 'Please insert the share link of the G-Sheet file.',
                    step3Line3:
                        'You must choose the line number to import, from the first line to the last line separated by a hyphen, example "2-6"',
                    step3Line4: 'The following lines will be created as an object:',
                    withFile: 'Creation with a G-sheet table :',
                    withoutFile: 'Without File'
                },
                title: 'Multiple creation'
            },
            currentStateName: 'Status',
            date: 'Creation date',
            dateTitle: 'Creation Date:',
            deleteModal: 'Are you sure you want to archive the selected item (s)?',
            deleteModalAlways: 'Are you sure you want to delete the selected item (s)?',
            deleteModalNotCancel: 'Are you sure you want to delete the selected item (s) without canceling the form?',
            deploy: 'Deploy',
            description: 'Description',
            documents: 'Documents',
            editObject: {
                add: {
                    mc: {
                        added: 'Communication Module was added',
                        error: 'Communication Module wasn\'t added',
                        title: 'Add communication Module to object'
                    }
                },
                title: 'Edit object'
            },
            export: {
                historic: {
                    csv: 'History (CSV)',
                    xlsx: 'History (XLSX)'
                },
                objects: {
                    csv: 'Inventory (CSV)',
                    xlsx: 'Inventory (XLSX)'
                }
            },
            filters: {
                avatarProperties: {
                    additionalInformation: 'Additional information',
                    definitionInput: 'AI - Classification',
                    definitionLabel: 'Additional information - Classification',
                    nameInput: 'AI - Name',
                    nameLabel: 'Additional information - Name',
                    valueInput: 'AI - Value',
                    valueLabel: 'Additional information - Value'
                },
                business: 'Business',
                creationDate: 'Creation date',
                creationDateAfter: 'Creation date - After',
                creationDateBefore: 'Creation date - Before',
                factory: 'Factory',
                historyCreated: 'History date',
                historyCreatedAtAfter: 'History date - After',
                historyCreatedAtBefore: 'History date - Before',
                history_name: 'Status Name',
                metadataAvatarType: 'Object Type',
                objectGroup: 'Group Object',
                objectName: 'Object name',
                parent: 'Object parent',
                shortUrl: 'ShortUrl',
                site: 'Construction site',
                typeObject: 'Object type name'
            },
            finger: 'Finger',
            generate: {
                create_from_file: 'Create Mcs from file',
                simulate: 'Simulate'
            },
            groupObjects: 'Objects Group',
            historic: 'History',
            info: {
                additionalAddress: 'Additional address',
                address: 'Address',
                altitude: 'Altitude',
                amountNotes: 'Number of notes',
                attachDocuments: 'Attach documents',
                attachImage: 'Upload an image',
                attachImages: 'Attach images',
                attachOneImage: 'Attach an image',
                chooseRootObjectType: 'Choose the root object type',
                city: 'City',
                country: 'Country',
                created: 'Date of creation',
                createdAt: 'Created At',
                description: 'Description',
                enabled: 'Enabled',
                enabledDate: 'Activation date',
                enterprise: 'Enterprise',
                extradata: 'Extra Data',
                extradata_infos: {
                    dimension: 'Dimension',
                    empty_: 'Open the Finger (WebApp) to check the information or contact the admin to personalise this information',
                    profession_data: 'Business data'
                },
                filter: {
                    apply: 'Apply as filter',
                    avatarGroup: 'Avatar Group',
                    company: 'Company',
                    history_created_at: {
                        afterFilter: 'History date - After',
                        beforeFilter: 'History date - Before',
                        value: 'History date'
                    },
                    metadataAvatarType: 'Object Type',
                    name: 'Filter',
                    note: 'Notes',
                    traceability: 'Traceability'
                },
                groupAvatar: {
                    name: 'Groups'
                },
                id: 'Id',
                image: 'Image',
                images: 'Images',
                inputMap: 'Click in the text to display the map',
                lastNote: 'Last Note',
                latitude: 'Latitude',
                localization: 'Localization',
                longitude: 'Longitude',
                mcs: 'Communication modules',
                name: 'Name of object',
                nature: 'MC type',
                parent: 'Object parent',
                position: 'Object Position',
                postalCode: 'Postal code',
                redirectTo: {
                    show: {
                        company: 'Display in the company page',
                        metadataAvatarType: 'Display in the object type page'
                    }
                },
                reference: 'Reference',
                showImages: 'Show all images',
                stateObject: 'Object status',
                statistics: 'Statistics',
                statistics_redirection: {
                    title: 'Detailed object statistics'
                },
                street: 'Street',
                tracking: {
                    _date_state: 'Status date',
                    currentNode: 'Current node',
                    date_state: 'Date of the Statute',
                    fullName: 'Full name',
                    goNext: 'Go next',
                    goPrevious: 'Go previous',
                    name_state: 'Status',
                    selectNode: 'Select a node',
                    title: 'Tracking'
                },
                type: 'Type of object'
            },
            information: 'Information',
            interfaces: 'Interface',
            list: {
                actions: {
                    customize_list: 'Customize'
                }
            },
            location: 'Location',
            mc: 'Communication Modules',
            moduleCommunications: 'Module Communications',
            name: 'Name',
            nameObject: 'Name object',
            nature: {
                nfc: 'NFC',
                qrcode: 'QrCode',
                st25: 'ST25'
            },
            notDefined: 'Not defined',
            notSelected: 'No object is selected',
            object: 'Object',
            objectMenu: {
                title: 'Select a Object'
            },
            objectType: 'Object Type',
            objects: 'Objects',
            openHistory: 'Open History',
            photoObject: 'Photo object',
            quantityMCs: 'Quantity MCs',
            service: 'Service redirection name',
            tabs: {
                mc: 'STOCK OF UNPAIRED MODULES COMMUNICANTS'
            },
            type: 'Type of Object',
            typeObject: {
                applicationDisponibles: 'Available Redirections'
            },
            typesObjects: 'Object Types',
            url: 'Url',
            webServiceDisplay: 'Web service to display'
        },
        productType: {
            create: 'Create',
            edit: 'Edit',
            name: 'Product type',
            yes: 'Yes',
            no: 'No',
            approval: 'Approval',
            approvalFile: 'Upload an approval file',
            mediaFile: 'Upload a file',
            addApproval: 'Add an approval',
            editApproval: 'Edit an approval',
            addItem: 'Add',
            editItem: 'Edit',
            deleteItem: 'Delete',
            messages: {
                success: 'Data has saved',
                error: 'Some error has occurred'
            },
            success: {
                updated: 'Product type has been updated'
            },
            error: {
                server: 'An error was found. Please contact the administrator'
            }
        },
        sidebar: {
            anc: 'Ancs monitoring',
            appName: 'ANC Backoffice',
            realTimeShort: 'real time',
            every2HoursShort: 'every 2 h',
            sections: {
                monitoring: 'Monitoring',
                reference: 'Reference data',
            },
            every2Hours: 'Updated every 2 hours',
            realTime: 'Real-time update',
            product_type: 'Product type',
            type: 'Type',
            threshold_settings: 'Threshold settings',
            disconnect: 'Sign out',
        },
        prestataires: {
            title: 'My Providers',
            menu: 'My Providers',
            columns: {
                companyName: 'Company',
                types: 'Type(s)',
                departments: 'Departments',
                email: 'Email',
                actions: 'Actions',
            },
            list: {
                empty: 'No affiliated providers yet.',
                summary: '%{companies} provider company(ies)',
            },
            actions: {
                add: 'Add a provider',
                refresh: 'Refresh',
                cancel: 'Cancel',
                back: 'Back',
                next: 'Next',
                link: 'Link',
                submit: 'Save',
                save: 'Save',
                edit: 'Edit',
                unlink: 'Unlink',
                viewPdf: 'View approval document',
                createAndLink: 'Create',
            },
            fields: {
                types: 'Service types',
                departments: 'Departments',
                departmentsHelp: 'Click departments on the map or search for an address',
                departmentsForType: 'Departments — %{type}',
                addressSearch: 'Search an address (IGN)',
                departmentsMapHelp: 'Click a department to add or remove it. The company address pre-selects its department.',
                departmentSearch: 'Add a department (code or name)',
                copyDepartmentsFrom: 'Copy departments from…',
                clearDepartments: 'Clear all',
                email: 'Provider email',
                companyName: 'Company name',
                siret: 'SIRET',
                adminEmail: 'Admin email',
                adminPassword: 'Admin password',
                adminName: 'Admin first name',
                adminLastName: 'Admin last name',
                street: 'Street',
                additionalAddress: 'Additional address',
                postalCode: 'Postal code',
                city: 'City',
                country: 'Country',
            },
            types: {
                MISE_EN_SERVICE: 'Commissioning',
                ENTRETIEN: 'Maintenance',
                REPARATION: 'Repair',
            },
            wizard: {
                title: 'Add a provider',
                steps: {
                    siret: 'SIRET',
                    details: 'Details',
                    company: 'Company',
                    zone: 'Service area',
                },
                siretHelp: "Enter the company's SIRET: we check whether it already exists in the system.",
                choosePdf: 'Choose a PDF',
                found: 'Company already in the system',
                foundHelp: 'It will be linked to your account, no need to create it again. Set its service types and departments.',
                notFound: 'No company with SIRET %{siret} in the system',
                alreadyAffiliated: '%{name} is already affiliated to your account.',
                notEligible: '%{name} exists in the system but is not an installer, maintainer or emptying company, so it cannot be affiliated.',
                companyBlock: 'Company information',
                adminBlock: 'Account administrator',
                annuairePrefilled: 'Prefilled from the French company directory (Annuaire des Entreprises), check them before saving.',
                annuaireClosed: 'Warning: this establishment is closed according to the Annuaire des Entreprises.',
                siretDigits: '%{count}/14 digits',
                createHelp: 'Fill in its details: the company and its administrator account will be created.',
                adminHelp: 'This account lets the provider sign in to the application.',
                adminEmailIsLogin: 'Used as the sign-in username',
                generatePassword: 'Generate a secure password',
                showPassword: 'Show password',
                hidePassword: 'Hide password',
                zoneHelp: 'Choose the services %{name} provides and, for each one, the departments covered.',
            },
            zone: {
                title: 'Service area per service',
                recenter: 'Recenter on France',
                legendActive: 'Current service',
                legendOther: 'Other services',
                addRegion: 'Add / remove a region',
                applyToAll: 'Apply to all services',
                selectedCount: '%{smart_count} department selected |||| %{smart_count} departments selected',
                emptySelection: 'No department yet. Click the map, search a department or add a region.',
                pickTypeFirst: 'Select at least one service type to define its service area.',
            },
            edit: {
                title: 'Edit affiliation',
                replacePdf: 'Replace approval document (optional)',
                addPdf: 'Add approval document (optional)',
                replacePdfHelp: 'Leave empty to keep the current document.',
            },
            validation: {
                typesRequired: 'Select at least one type',
                departmentsRequired: 'Enter at least one valid department',
                departmentsRequiredForType: 'Select at least one department for %{type}',
                siretInvalid: 'SIRET must contain 14 digits',
                required: 'Required field',
                emailInvalid: 'Invalid email address',
            },
            messages: {
                createSuccess: 'Provider added successfully',
                updateSuccess: 'Affiliation updated',
                unlinkSuccess: 'Affiliation unlinked',
                confirmUnlink: 'Unlink this provider?',
                pdfUnavailable: 'No approval document',
                missingCompany: 'Manufacturer company not found',
                error: 'An error occurred',
            },
        },
        login: {
            heroTitle: 'Tracking of on-site wastewater installations',
            heroText: 'From delivery to commissioning: traceability, signatures and documents of each installation.',
            title: 'Login',
            subtitle: 'Sign in with your username and password.',
            username: 'Username',
            password: 'Password',
            submit: 'Sign in',
            error: 'Invalid username or password',
        },
        pwa: {
            info: 'Info',
            title: 'Add to Home Screen',
            intro: 'You can access the application like an app from your phone.',
            close: 'Close',
            qr: {
                title: 'Open on mobile',
                hint: 'Scan this code with your phone camera to open the backoffice.',
            },
            install: {
                title: 'Install the app',
                message: 'Add Rikutec to your home screen to access it directly, like a native app.',
                action: 'Install',
                later: 'Later',
            },
            android: {
                title: 'Android (Chrome)',
                step1: 'Open the site in Chrome.',
                step2: 'Tap the ⋮ menu in the top-right corner.',
                step3: 'Select "Add to Home screen" or "Install app".',
            },
            ios: {
                title: 'iOS (Safari)',
                step1: 'Open the site in Safari.',
                step2: 'Tap the Share button at the bottom of the screen.',
                step3: 'Select "Add to Home Screen", then confirm.',
            },
        },
        traceabilityNotesThreshold: {
            name: 'Threshold',
            operationType: 'Operation Type',
            activeEvent: 'Active event',
            objectType: 'Object Type',
            deleted: 'The threshold was well deleted',
            actions: {
                title: 'Actions',
                addEvent: 'Add threshold',
                deleteEvent: 'Delete threshold',
                editEvent: 'Edit threshold',
                managementThresholds: 'Management threshold',
                defineThresholds: 'Define trigger thresholds from the last date of the selected event',
                export: 'Export',
                statistics: 'Statistics',
                refresh: 'Refresh',
                personalize: 'Personalize',
                delete: {
                    title: 'Delete threshold?',
                    message: 'Are you sure you want to delete the threshold?'
                }
            },
            error: {
                server: 'A server error has occurred. Please contact the administrator',
                uniqueMetadataAvatarType: 'There is a notification linked to this type object',
                set: {
                    groupAvatar: 'Object group must be defined',
                    avatar: 'Object must be defined',
                    metadataAvatarType: 'Object type must be defined'
                }
            },
            maintenance: {
                name: 'Maintenance threshold'
            },
            emptying: {
                name: 'Emptying threshold'
            }
        },
        types: {
            productName: 'Name',
            productType: 'Product Type',
            alpha_id: 'Alpha Id',
            id: 'Id',
            name: 'Name of type',
            processingCapacity: 'Processing Capacity',
            sludgeStorageVolume: 'Sludge Storage Volume',
            totalUsefulVolume: 'Total Useful Volume',
            model: 'Model',
            itemCode: 'Item code',
            typeSerialNumber: 'First 4 digit of serial number',
            create: 'Create Type',
            edit: 'Edit',
            empty: '<empty>',
            addEditInstallingGuide: 'Add / Edit Installing Guide',
            addEditinstalling_guide: 'Add / Edit Installing Guide',
            installing_guide: 'Installing guide',
            user_booklet: 'User\'s booklet',
            user_guide: 'Use and Care Guide',
            reflex_emtying: 'Emptying Reflex Sheet',
            reflex_maintenance: 'Maintenance Reflex Sheet',
            technical_sheet: 'Technical Sheet',
            routine_maintenance: 'Routine Maintenance',
            addReflexEmtying: 'Add Emptying Reflex Sheet',
            addReflexMaintenance: 'Add Maintenance Reflex Sheet',
            addInstallingGuide: 'Add Installing Guide',
            addUserBooklet: 'Add User booklet',
            addUserGuide: 'Add User Guide',
            addTechnicalSheet: 'Add Technical Sheet',
            addRoutineMaintenance: 'Add Routine Maintenance',
            enableApproval: 'Enable accreditation',
            disableApproval: 'Disable accreditation',
            approvalEnabled: 'Accreditation enabled',
            approvalDisabled: 'Accreditation disabled',
            mediaFile: 'Upload a file',
            addEditUserGuide: 'Add / Edit User Guide',
            addEdituser_guide: 'Add / Edit User Guide',
            addEditTechnicalSheet: 'Add / Edit Technical Sheet',
            addEdittechnical_sheet: 'Add / Edit Technical Sheet',
            addEditRoutineMaintenance: 'Add / Edit Routine Maintenance',
            addEditroutine_maintenance: 'Add / Edit Routine Maintenance',
            yes: 'Yes',
            no: 'No',
            messages: {
                success: 'Data has saved',
                error: 'Some error has occurred'
            }
        },
        notification: {
            copied: 'Copied successfully'
        },
        download: 'Download',
        validation: {
            required: 'Field is required'
        },
        yes: 'Yes'
    },
};

// Added translations for notes module
// Extend without altering existing structure to avoid large diffs
// eslint-disable-next-line @typescript-eslint/no-explicit-any
(locale.app as any).notes = {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    ...(locale.app as any).notes,
    makeBy: 'Made by',
    formsDialog: 'Forms',
};
// eslint-disable-next-line @typescript-eslint/no-explicit-any
(locale.app as any).main_buttons = {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    ...(locale.app as any).main_buttons,
    actions: 'Actions',
    back: 'Back',
    create: 'Create',
    delete: 'Delete',
    edit: 'Edit',
    next: 'Next',
    openForms: 'Open forms',
    return: 'Return',
};
// eslint-disable-next-line @typescript-eslint/no-explicit-any
(locale.app as any).objects = {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    ...(locale.app as any).objects,
    documents: 'Documents',
};
// eslint-disable-next-line @typescript-eslint/no-explicit-any
(locale.app as any).signs = 'Signs';
// eslint-disable-next-line @typescript-eslint/no-explicit-any
(locale.app as any).rikutec = {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    ...(locale.app as any).rikutec,
    externalIdentification: {
        label: 'External identification',
        name: 'Name',
        email: 'Email',
    },
};

export default locale;
